// extracted by mini-css-extract-plugin
module.exports = {"history":"PointHistory_history__5eqyM","date":"PointHistory_date__RWfqR"};